import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { colors } from 'Constants/Colors';

export const ReportsLayoutFiltersContainer = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  border-radius: 8px;
  align-items: end;

  .reset-button-container {
    grid-column: 1 / -1;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }
`;

export const ResetButton = styled(Button)`
  color: ${colors.RED};
  border-color: ${colors.RED};
  text-transform: none;
  height: 50px;
  min-width: 100px;
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};

  &:hover {
    border-color: ${colors.RED};
  }
`;

export const SearchButton = styled(Button)`
  color: ${colors.GREEN};
  border-color: ${colors.GREEN};
  text-transform: none;
  height: 50px;
  min-width: 80px;
  display: ${({ hidden }) => (hidden ? 'none' : undefined)};

  &:hover {
    border-color: ${colors.GREEN};
  }
`;
